import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledButton = styled(UIButton).withConfig({
  displayName: "ActionButton__StyledButton",
  componentId: "sc-1s6ua5o-0"
})(["padding-left:0;padding-right:0;margin:0 !important;@media screen and (max-width:1212px){i18n-string{display:none;}}"]);
export const ActionButton = _ref => {
  let {
      children,
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const newProps = Object.assign({}, rest, {
    use: 'tertiary-light',
    className: `${className} m-all-0`,
    size: 'sm'
  });
  return /*#__PURE__*/_jsx(StyledButton, Object.assign({}, newProps, {
    children: children
  }));
};
ActionButton.displayName = 'ActionButton';
export default ActionButton;